import React, { useCallback, useLayoutEffect } from 'react';
import { ScrollView, View } from 'react-native';
import Choices from 'design-system/Choices';
import StatusBar from 'design-system/StatusBar';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useColors from 'hooks/useColors';
import { useAppDispatch } from 'store/hooks';
import { OnboardingFlow } from 'utils/types/navigation';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import useNavigateToNextScreenForPotsOnboarding from 'features/pots/hooks/useNavigateToNextScreenForPotsOnboarding';
import LeaveOnboardingButton from 'features/wealth/components/LeaveOnboardingButton';
import { useCommonInvestStyles } from './styles';
import { useAmplitudeOnMountEvent } from '../utils/analytics';
import InvestHeaderWithHelpButton from '../components/InvestHeaderWithHelpButton';
import { strings as onboardingTitleStrings } from '../components/OnboardingTitle';
import useNavigateToNextScreen from '../hooks/useNavigateToNextScreen';
const CHOICES_MAP = {
    '£0 - £29,999': { annualIncomeMin: 0, annualIncomeMax: 29999 },
    '£30,000 - £49,999': { annualIncomeMin: 30000, annualIncomeMax: 49999 },
    '£50,000 - £99,999': { annualIncomeMin: 50000, annualIncomeMax: 99999 },
    '£100,000 - £499,000': { annualIncomeMin: 100000, annualIncomeMax: 499000 },
    '> £500,000': { annualIncomeMin: 500000, annualIncomeMax: 10000000 },
};
const CHOICES = Object.keys(CHOICES_MAP);
const AnnualIncomeScreen = ({ navigation, route: { params } }) => {
    const commonStyles = useCommonInvestStyles(params?.mountedOnAnotherScreen);
    const colors = useColors();
    useAmplitudeOnMountEvent(params?.flow, !!params?.mountedOnAnotherScreen, 'User Income Screen');
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
            headerRight: () => (<HelpScreenButton articlesKey={params?.flow === OnboardingFlow.Pots ? HELP_ARTICLES_KEY.POTS_ONBOARDING : undefined}/>),
        });
    }, [colors.text.primary, params?.flow]);
    const dispatch = useAppDispatch();
    const navigateToNextScreen = useNavigateToNextScreen();
    const navigateToNextScreenForPots = useNavigateToNextScreenForPotsOnboarding();
    const onSubmit = useCallback(async (annualIncomeChoiceKey) => {
        const newParams = {
            ...CHOICES_MAP[annualIncomeChoiceKey],
        };
        dispatch({ type: 'SAVE_ONBOARDING_STATE', screen: 'InvestNetWorth', params: newParams });
        if (params?.flow === OnboardingFlow.Pots || params?.flow === OnboardingFlow.Wallet) {
            navigateToNextScreenForPots();
        }
        else {
            navigateToNextScreen();
        }
    }, [navigateToNextScreen, navigateToNextScreenForPots, params?.flow]);
    return (<View style={commonStyles.containerNoPadding}>
      <StatusBar barStyle="dark-content" animated/>
      <InvestHeaderWithHelpButton hideButton={!params?.mountedOnAnotherScreen} isPotsOnb={params?.flow === OnboardingFlow.Pots} leftContent={params?.mountedOnAnotherScreen ? <LeaveOnboardingButton flow={params.flow}/> : undefined}/>
      <ScrollView scrollEnabled={false} contentContainerStyle={commonStyles.contentContainer}>
        <ScreenInfoHeader title={onboardingTitleStrings.Income.title} subTitle={onboardingTitleStrings.Income.subtitle}/>
        <View style={commonStyles.withPadding}>
          <Choices numbers data={CHOICES} onSelect={onSubmit}/>
        </View>
      </ScrollView>
    </View>);
};
export default AnnualIncomeScreen;
